var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00043 14.4349C11.5544 14.4349 14.4354 11.5539 14.4354 7.99994C14.4354 4.44599 11.5544 1.56494 8.00043 1.56494C4.44648 1.56494 1.56543 4.44599 1.56543 7.99994C1.56543 11.5539 4.44648 14.4349 8.00043 14.4349Z",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8453 9.65747C10.5489 10.155 10.1299 10.5681 9.62834 10.8575C9.12673 11.1468 8.55929 11.3026 7.98027 11.31C7.4143 11.3036 6.85899 11.1552 6.36536 10.8782C5.87174 10.6013 5.45563 10.2047 5.15527 9.72497",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.905 6.655C6.05964 6.655 6.185 6.52964 6.185 6.375C6.185 6.22036 6.05964 6.095 5.905 6.095C5.75036 6.095 5.625 6.22036 5.625 6.375C5.625 6.52964 5.75036 6.655 5.905 6.655Z",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0896 6.65497C10.2442 6.65497 10.3696 6.52961 10.3696 6.37497C10.3696 6.22033 10.2442 6.09497 10.0896 6.09497C9.93493 6.09497 9.80957 6.22033 9.80957 6.37497C9.80957 6.52961 9.93493 6.65497 10.0896 6.65497Z",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.b3a7a5d313c194673d2b4cba5ec91eff.svg";
export { ForwardRef as ReactComponent };